import TeamsPageNameCell from 'pages/Teams/Cells/NameCell';
import type { ManagedFleet } from '../..';

interface SentinelTeamNameCellProps {
  rowData: ManagedFleet;
}

export default function SentinelTeamNameCell({
  rowData: { sentinelTeam },
}: SentinelTeamNameCellProps) {
  return (
    <TeamsPageNameCell
      hideLogo
      rowData={{
        id: sentinelTeam.id,
        name: sentinelTeam.name,
        teamKey: sentinelTeam.teamKey,
      }}
      openInNewTab
    />
  );
}
